import { defineMessages, useIntl } from 'react-intl';

import { HeroBlock } from '@sorare/core/src/components/landing/HeroBlock';
import { Hero as RivalsHero } from '@sorare/core/src/components/landing/RivalsHeroBlock';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';

import heroBackgroundVideo from './assets/heroBackgroundVideo.webm';
import heroVideoPoster from './assets/heroVideoPoster.jpg';
import slideShow_1 from './assets/slideShow_1.jpg';

const messages = defineMessages({
  title: {
    id: 'Football.Landing.Hero.title',
    defaultMessage: 'Fantasy Football.{br}Reimagined.',
  },
  subtitle: {
    id: 'Football.Landing.Hero.subtitle',
    defaultMessage:
      'Sorare is a next-level fantasy football game where you collect and compete with ownable digital player cards to win cash, tickets, VIP experiences, and more.',
  },
  additionalText: {
    id: 'Football.Landing.Hero.additionalText',
    defaultMessage:
      'Build your roster by buying, selling, and trading player cards from the world’s top leagues. No matter where you finish in competitions, you still own your cards.',
  },
});

export const Hero = () => {
  const { formatMessage } = useIntl();
  const {
    flags: { useRivalsLanding = false },
  } = useFeatureFlags();

  if (useRivalsLanding) {
    return <RivalsHero scrollDownText={undefined} />;
  }
  return (
    <HeroBlock
      poster={heroVideoPoster}
      videoSrc={heroBackgroundVideo}
      subtitle={formatMessage(messages.subtitle)}
      additionalText={formatMessage(messages.additionalText)}
      title={formatMessage(messages.title, { br: <br /> })}
      mobileSlides={[slideShow_1]}
    />
  );
};
